import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'table ordering',
    [ORDER_METHODS.PICKUP]: 'pickup',
    [ORDER_METHODS.DELIVERY]: 'delivery',
  },
  errors: {
    draft_validation_failed: 'Please complete your delivery address before continuing.',
  },
};
